
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/btl-results",
      function () {
        return require("private-next-pages/btl-results.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/btl-results"])
      });
    }
  